'use strict';

var Backbone = require('backbone'),
  _ = require('underscore'),
  mediator = require('../../js/mediator'),
  Analytics = require('../Analytics/Analytics'),
  config = require('../../js/config'),
  $global = require('../../js/globalElements'),
  myCartTemplate = require('./templates/_MyCart.hbs'),
  Cart = require('../Cart/Cart').default,
  MyCartView;

import * as featureFlags from '../../utilities/featureFlags';

MyCartView = Backbone.View.extend({
  template: myCartTemplate,
  events: {
    'click > a': 'showMyCart'
  },

  initialize: function() {
    this.initialiseElements();
    this.initialiseEvents();
    this.initialiseCart();
  },

  initialiseElements: function() {
    this.$cart = this.$('.MyCart');
  },

  initialiseEvents: function() {
    mediator.on(config.events.cart.added, this.renderMyCart, this);
    mediator.on(config.events.header.openingDropdownView, this.onDropdownsOpening, this);
    mediator.on(config.events.cart.updated, this.renderMyCart, this);
    mediator.on(config.events.ui.scrollThrottle, this.hideMyCart, this);
  },

  initialiseCart: function() {
    // Get the current cart from local storage
    Cart.get().done(_.bind(this.renderMyCart, this));
  },

  renderMyCart: function(cart) {
    var cartHtml = '';

    if (cart) {
      cart.chatUrl = config.chatWindow.url;
      cartHtml = this.template(cart);
    }

    this.$cart.html(cartHtml);
  },

  showMyCart: function(e) {
    if (!featureFlags.MiniCartSuppression.isEnabled()) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        Analytics._basicPush(e);
      }
      //Close if it's already open
      if (this.$cart.hasClass(config.classes.isOpen)) {
        this.hideMyCart();
        return;
      }

      //Show the dropdown only if there are items in the cart
      if (this.$('.MyCart-product').length && window.innerWidth >= config.minimisedHeader.breakpoint) {
        mediator.trigger(config.events.header.openingDropdownView, this);
        this.$cart.addClass(config.classes.isOpen);
        this.$cart.css('height', this.$('.MyCart-inner').outerHeight());
        $global.$body.addClass(config.classes.hasMyCartDropdown);
        $global.$body.on('click.hideMyCart', _.bind(this.hideMyCart, this));
      } else {
        mediator.trigger(config.events.requestPageReload, this.$el.children('a').attr('href'));
      }
    }
  },

  onDropdownsOpening: function(view) {
    if (view !== this) this.hideMyCart();
  },

  itemDeleted: function() {
    Cart.load();
  },

  hideMyCart: function() {
    this.$cart.removeClass(config.classes.isOpen);
    $global.$body.removeClass(config.classes.hasMyCartDropdown);
    $global.$body.off('click.hideMyCart');
    // Needed to remove CSS hover effect when clicking to close
    this.$el.css('pointer-events', 'none');
    _.defer(function($el) {
      $el.css('pointer-events', '');
    }, this.$el);
  }

});

module.exports = MyCartView;



// WEBPACK FOOTER //
// ./assets/components/MyCart/MyCartView.js